import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const DropdownPortal = ({ children, targetElement }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted || !targetElement) {
    return null;
  }

  const rect = targetElement.getBoundingClientRect();
  const styles = {
    position: "absolute",
    top: `${rect.bottom + window.scrollY}px`,
    left: `${rect.left + window.scrollX}px`,
    zIndex: 1001,
  };

  return createPortal(
    <div style={styles}>{children}</div>,
    document.body
  );
};

export default DropdownPortal;